export default "__VITE_ASSET__C_$h3Ebg__"